class CalculatorsHelper {
  inputFields: string[] = [];
  outputFields: string[] = [];

  generateInputAndOutputFields(
    inputFields: string[],
    outputFields: string[],
    field: string,
    fieldValue: string | number,
    calcType: string,
    minInputFieldsQty: number
  ) {
    this.inputFields = [...inputFields];
    this.outputFields = [...outputFields];

    const inputFieldIndex = this.inputFields.indexOf(field);
    const outputFieldIndex = this.outputFields.indexOf(field);

    if (typeof fieldValue === 'string' && fieldValue.length === 0) {
      if (inputFieldIndex >= 0) {
        this.inputFields.splice(inputFieldIndex, 1);
        this.outputFields.push(field);

        const firstOutputFieldElement: HTMLInputElement = document.querySelector(`#${calcType}-${this.outputFields[0]}-input`);

        if (firstOutputFieldElement && firstOutputFieldElement.value) {
          this.inputFields.push(this.outputFields.shift());
        }
      }
    } else {
      if (inputFieldIndex >= 0) {
        this.inputFields.splice(inputFieldIndex, 1);
        this.inputFields.push(field);
      } else {
        if (outputFieldIndex >= 0) {
          this.outputFields.splice(outputFieldIndex, 1);

          if (this.inputFields.length === minInputFieldsQty) {
            this.outputFields.push(this.inputFields.shift());
          }

          this.inputFields.push(field);
        } else {
          console.log('this shouldnt happen!!!');
        }
      }
    }
  }

  getInputFields() {
    return this.inputFields;
  }

  getOutputFields() {
    return this.outputFields;
  }
}

export default new CalculatorsHelper();
